// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2MGd3","overflowing":"ReadFullNote_overflowing__M7Ft7"};